/**
 * SetupRequiredBanner - banner globale che invita TITOLARE/ADMIN a
 * completare la configurazione iniziale dello studio (BUG-1 fix C).
 *
 * Visibile solo se NON esiste una P.IVA predefinita ATTIVA configurata:
 * senza P.IVA non si possono emettere fatture e i nuovi pazienti non
 * ereditano l'autofill, quindi e' lo step bloccante.
 *
 * La collection /operatori e' OPZIONALE: una TITOLARE puo' lavorare
 * da sola assegnando pazienti a se stessa. Per questo non rientra nel
 * banner di blocco.
 *
 * Non e' dismissibile a mano. Sparisce automaticamente non appena la
 * P.IVA predefinita e' impostata.
 *
 * Renderizzato sopra AppTopBar in AppShell.
 */

import { useNavigate } from 'react-router-dom';
import { Icon } from '@shared/components/ui/Icon';
import { useAuth } from '../../hooks/useAuth';
import { usePartitaIvaPredefinita } from '../../hooks/useOperatori';

export function SetupRequiredBanner() {
  const navigate = useNavigate();
  const { role } = useAuth();
  const { data: predefinita, isLoading } = usePartitaIvaPredefinita();

  // Solo TITOLARE/ADMIN possono configurare studio.
  if (role !== 'TITOLARE' && role !== 'ADMIN') {
    return null;
  }

  // Niente flash falso positivo durante il primo fetch.
  if (isLoading) {
    return null;
  }

  // Setup completato: esiste una P.IVA predefinita ATTIVA.
  if (predefinita) {
    return null;
  }

  return (
    <div
      role="alert"
      aria-live="polite"
      className="bg-amber-50 border-b border-amber-300 text-amber-900"
    >
      <div className="max-w-container-max-width mx-auto px-margin-mobile md:px-margin-desktop py-3 flex items-start md:items-center gap-3 flex-wrap">
        <Icon
          name="warning"
          size={20}
          className="text-amber-600 shrink-0 mt-0.5 md:mt-0"
          aria-hidden
        />
        <p className="text-sm flex-1 min-w-0">
          <strong className="font-semibold">
            Configurazione iniziale necessaria.
          </strong>{' '}
          Imposta una P.IVA predefinita per iniziare a usare DietaGest.
        </p>
        <button
          type="button"
          onClick={() => navigate('/app/impostazioni/partite-iva')}
          className="h-11 px-4 rounded-lg text-sm font-semibold bg-amber-600 text-white hover:bg-amber-700 min-w-[44px] inline-flex items-center gap-2 shrink-0"
        >
          <Icon name="settings" size={18} aria-hidden />
          Configura ora
        </button>
      </div>
    </div>
  );
}
